
import React, { useEffect, useState } from "react"
import { useAuth } from "../../contexts/authContext"
import { Link, useHistory, useLocation } from "react-router-dom"

export default function Signup() {
  const { signup, currentUser } = useAuth()
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const location = useLocation()

  useEffect(()=>{
    const goToPath = location.state && location.state.from ? location.state.from.pathname :"/serie/test/question/1"
    if(currentUser){
      history.push(goToPath);
    } 
  },[currentUser])

  async function handleSubmit(e) {
    e.preventDefault()
    const formData = [...new FormData(e.target)].reduce((acc,[key, value])=>{
        return({...acc, [key]:value});
      },{});

    if (formData.password !== formData.confirmPassword) {
      return setError("Passwords do not match")
    }

    try {
      setError("")
      setLoading(true)
      await signup(formData.username, formData.email, formData.password)
    } catch {
      setError("Failed to create an account")
    }

    setLoading(false)
  }


  return (<div className="login-page">
    <div className="container">
        <h2> الإشتراك بالمجان</h2>
        {error && <div className="warning">{error}</div>}
        <form onSubmit={handleSubmit}>

          <label className="sr-only">
            الإسم الكامل
          </label>
            <input type="text" name="username" placeholder='الإسم الكامل' required/>
          <label className="sr-only">
            البريد الإلكتروني
          </label>
            <input type="email" name="email" placeholder='البريد الإلكتروني' required/>
          <label className="sr-only">
            كلمة المرور
            </label>
            <input  type="password" name="password" placeholder="كلمة المرور" required/>
            <label className="sr-only">
            تأكيد كلمة المرور 
            </label>
            <input  type="password" name="confirmPassword" placeholder="تأكيد كلمة المرور" required/>
            <button type="submit" disabled={loading}>تسجيل الإشتراك</button>
        </form>
      <div className="log-link">
      هل لديك حساب؟ &nbsp;&nbsp; <Link to="/login">تسجيل الدخول</Link>
      </div>
    </div>
    </div>
  )
}
